import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';
import { toURLSearchParams } from '@/utils/url';

import { type PricingsFiltersApi, pricingsApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const pricing = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}` }));

export const fetchPricings = async (
  searchParams: PricingsFiltersApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  const {
    branchKey,
    cargoType,
    carrierKey,
    currencyCode,
    effectiveDate,
    expirationDate,
    isDangerousGoods,
    modeType,
    packageType,
    pricingBasis,
    pricingKey,
    pricingType,
    serviceKey,
    skip,
    sorting,
    take,
    trailerKey,
  } = searchParams;

  try {
    return await pricing
      .get('pricing/search', {
        searchParams: toURLSearchParams({
          BranchKey: branchKey,
          CargoType: cargoType,
          CarrierKey: carrierKey,
          CurrencyCode: currencyCode,
          EffectiveDate: effectiveDate,
          ExpirationDate: expirationDate,
          IsDangerousGoods: isDangerousGoods,
          ModeType: modeType,
          PackageType: packageType,
          PricingBasis: pricingBasis,
          PricingKey: pricingKey,
          PricingType: pricingType,
          ServiceKey: serviceKey,
          Skip: skip,
          Sorting: sorting || undefined,
          Take: take,
          TrailerKey: trailerKey,
        }),
        signal,
      })
      .json(pricingsApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Pricing search error: ${error.response.status}`);
    }
    throw error;
  }
};
